import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog/dialog';
import { StyledFullLayout } from '~/components/dialog/styles/styled-dialog';
import { state } from '~/storage';

type IframeDialogData = {
	url: string;
	name: string;
};

export function useIframeDialog() {
	const [iframeDialog, setIframeDialog] = useAtom(state.iframeDialog);

	return {
		data: iframeDialog,
		showIframeDialog: useCallback(
			(data: IframeDialogData) => {
				setIframeDialog(data);
			},
			[setIframeDialog],
		),
		open: !!iframeDialog,
		close: useCallback(() => {
			setIframeDialog(null);
		}, [setIframeDialog]),
		trackClosing: useCallback(() => {
			appTrackingService.summaryClickEvent({
				eventAction: EventAction.InternalLink,
				eventName: `configurator - click to close layer`,
				componentName: iframeDialog?.name || '',
			});
			appTrackingService.viewChangeEvent({
				eventName: 'generic',
			});
		}, [iframeDialog?.name]),
	};
}

export function IframeDialog() {
	const { open, close, data, trackClosing } = useIframeDialog();
	return (
		<Dialog
			onCloseButtonClick={() => {
				trackClosing();
				close();
			}}
			open={open}
			classNameContent={'h-full w-full'}>
			{data && <IframeDialogContent url={data.url} />}
		</Dialog>
	);
}

function IframeDialogContent({ url }: { url: string }) {
	return (
		<StyledFullLayout direction="column" rowGap="32px">
			<StyledFullLayout direction="column" rowGap="16px">
				<iframe src={url} title="iFrame dialog" />
			</StyledFullLayout>
		</StyledFullLayout>
	);
}
